export default "__VITE_ASSET__DTJ3QvM5__"